import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getQueuesResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmQueuesNewRoute } from '@jira/router-routes__servicedesk-queues-routes/src/csmQueuesNewRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { queuesCreateViewEntryPoint } from '@jira/spa-apps__servicedesk-queues-create-view/src/queuesCreateViewEntryPoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const csmQueuesNewPageEntryPoint = createPageEntryPoint({
	main: queuesCreateViewEntryPoint,
});

export const csmQueuesNewRouteEntry: Route = createEntry(csmQueuesNewRoute, () => ({
	group: 'customer-service',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdCsmApp,
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getQueuesResources(),
		getConsolidationStateResource(),
	],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmQueuesNewPageEntryPoint
			: notFoundPageEntrypoint;
	},

	forPaint: [LazyAtlassianNavigation],
	ufoName: 'service-management.queues.new',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
